import { withInstall } from "../utils/index.mjs";
import _ActionBar from "./ActionBar.mjs";
const ActionBar = withInstall(_ActionBar);
var stdin_default = ActionBar;
import { actionBarProps } from "./ActionBar.mjs";
export {
  ActionBar,
  actionBarProps,
  stdin_default as default
};
